import { createAction, createReducer } from 'redux-act';

import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  notes: [],
  dialogOpen: false,
});

export const createNote = createAction('CREATE_NOTE');
export const loadNotes = createAction('LOAD_NOTES');
export const loadNotesSucceeded = createAction('LOAD_NOTES_SUCCEEDED');
export const deleteNote = createAction('DELETE_NOTE');
export const setDialogOpen = createAction('SET_NOTE_DIALOG');

const reducers = createReducer({
  [loadNotesSucceeded]: (state, notes) => state.merge({ notes }),
  [setDialogOpen]: (state, dialogOpen) => state.merge({
    dialogOpen,
  }),
}, INITIAL_STATE);

export default reducers;
